import React from "react";
import classNames from "classnames";

import { Text } from "../../../atoms/Text/Text";
import { User } from "../../../models/User";

import { FriendTabs } from "../../../services/Friend/FriendService";
import ChallengeService from "../../../services/Friend/ChallengeService";
import { ChallengeStatsByDateModel } from "../../../models/Challenge";

import styles from "./FriendChallenge.css";

type RenderSendChallengesProps = {
  list: ChallengeStatsByDateModel[];
  user: User;
  tabId: FriendTabs;
  isOpened: boolean;
  onTabSelect: (tabId: FriendTabs, gameId?: number) => void;
};

export class RenderSendChallenges extends React.Component<RenderSendChallengesProps> {
  renderRows() {
    const { onTabSelect, list } = this.props;

    return list.map((record: ChallengeStatsByDateModel, i) => (
      <tr key={i} className={record.friendActivity && styles.show_activity_badge}>
        <td>{ChallengeService.formatDateToLiteral(record.date)}</td>
        <td align="center">{record.totalChallenges || 0}</td>
        <td align="center">{record.wagers || 0} of 3</td>
        <td>
          <button
            onClick={() =>
              onTabSelect(FriendTabs.ViewChallengeByDate, record.puzzleId)
            }
            type="button"
          >
            View
          </button>
        </td>
      </tr>
    ));
  }

  render() {    
    const { isOpened, tabId, list } = this.props;
    return (
      <div
        role="tabpanel"
        id={tabId}
        className={classNames({ [styles.hiddenFriendTable]: !isOpened })}
        aria-labelledby={`tab${tabId}`}
      >
        <Text
          className={classNames(styles.challenge_cta, styles.open)}
        >
          Challenge your friends from the list below to see who can have the top score!
          You can challenge all of your friends, but can only place wagers with 3 friends per game.
        </Text>

        <table className={styles.challenges_table}>
          <thead>
            <tr>
              <th>Game Date</th>
              <th align="center">Challenges</th>
              <th align="center">Wagers</th>
              <th></th>
            </tr>
          </thead>
          {list && <tbody>{this.renderRows()}</tbody>}
        </table>
      </div>
    );
  }
}
